import React, { Component } from "react"
import mapboxgl from "mapbox-gl"
import "./mapstyles.css"
mapboxgl.accessToken = process.env.GATSBY_MAPBOX_KEY

//test
class MapboxFile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lng: 15.235267454886867,
      lat: 44.12542,
      zoom: 13,
    }
  }
  componentDidMount() {
    // bez tokena Mapbox baca grešku koja sruši cijelu stranicu
    if (!mapboxgl.accessToken) return
    const map = new mapboxgl.Map({
      container: this.mapContainer,
      style: "mapbox://styles/lovreperaic/ckjub2489003019mf8fy983si",
      center: [this.state.lng, this.state.lat],
      zoom: this.state.zoom,
      attributionControl: false,
    })
  }

  render() {
    if (!mapboxgl.accessToken) {
      const { lng, lat } = this.state
      const d = 0.012
      const bbox = [lng - d * 1.6, lat - d, lng + d * 1.6, lat + d].join(",")
      return (
        <div>
          <iframe
            className="mapContainer"
            title="Karta - SF Konzalting"
            src={`https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lng}`}
            style={{ border: 0, width: "100%", position: "relative", zIndex: 1 }}
            loading="lazy"
          />
        </div>
      )
    }
    return (
      <div>
        <div ref={el => (this.mapContainer = el)} className="mapContainer" />
      </div>
    )
  }
}

export default MapboxFile
